import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { useAuth } from '../context/AuthContext';
import api from '../services/api';
import './BookMeeting.css';

const MEETING_ICONS = {
  'technical-support': '\u{1F527}',
  'technical_support': '\u{1F527}',
  'sales-consultation': '\u{1F4BC}',
  'sales_consultation': '\u{1F4BC}',
  'quotation-discussion': '\u{1F4B0}',
  'quotation_discussion': '\u{1F4B0}',
  'consultation': '\u{1F4CA}',
  'demo': '\u{1F5A5}',
  'training': '\u{1F4DA}',
  'onboarding': '\u{1F680}',
  'sales': '\u{1F4BC}'
};

const BookMeeting = () => {
  const { language, isRTL } = useLanguage();
  const { client } = useAuth();
  const navigate = useNavigate();
  
  const [step, setStep] = useState(1);
  const [loading, setLoading] = useState(false);
  
  const [departments, setDepartments] = useState([]);
  const [selectedDept, setSelectedDept] = useState(null);
  
  const [meetingTypes, setMeetingTypes] = useState([]);
  const [selectedType, setSelectedType] = useState(null);
  
  const [agents, setAgents] = useState([]);
  const [selectedAgent, setSelectedAgent] = useState(null);
  
  const [slots, setSlots] = useState([]);
  const [availableDates, setAvailableDates] = useState([]);
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedSlot, setSelectedSlot] = useState(null);
  const [agentConnectionMethods, setAgentConnectionMethods] = useState([]);
  
  const [formData, setFormData] = useState({
    name: '', phone: '', email: '', reason: '', connection_method: ''
  });
  
  const [bookingResult, setBookingResult] = useState(null);
  const [error, setError] = useState('');

  const t = (key) => {
    const tr = {
      bookMeeting: { en: 'Book a Meeting', ar: '\u062d\u062c\u0632 \u0645\u0648\u0639\u062f' },
      selectDepartment: { en: 'Select Department', ar: '\u0627\u062e\u062a\u0631 \u0627\u0644\u0642\u0633\u0645' },
      selectMeetingType: { en: 'Select Meeting Type', ar: '\u0627\u062e\u062a\u0631 \u0646\u0648\u0639 \u0627\u0644\u0645\u0648\u0639\u062f' },
      selectAgent: { en: 'Select Agent', ar: '\u0627\u062e\u062a\u0631 \u0627\u0644\u0645\u0648\u0638\u0641' },
      selectDateTime: { en: 'Select Date & Time', ar: '\u0627\u062e\u062a\u0631 \u0627\u0644\u062a\u0627\u0631\u064a\u062e \u0648\u0627\u0644\u0648\u0642\u062a' },
      yourDetails: { en: 'Your Details', ar: '\u0628\u064a\u0627\u0646\u0627\u062a\u0643' },
      back: { en: 'Back', ar: '\u0631\u062c\u0648\u0639' },
      confirm: { en: 'Confirm Booking', ar: '\u062a\u0623\u0643\u064a\u062f \u0627\u0644\u062d\u062c\u0632' },
      name: { en: 'Full Name', ar: '\u0627\u0644\u0627\u0633\u0645 \u0627\u0644\u0643\u0627\u0645\u0644' },
      phone: { en: 'Phone Number', ar: '\u0631\u0642\u0645 \u0627\u0644\u0647\u0627\u062a\u0641' },
      email: { en: 'Email', ar: '\u0627\u0644\u0628\u0631\u064a\u062f \u0627\u0644\u0625\u0644\u0643\u062a\u0631\u0648\u0646\u064a' },
      reason: { en: 'Meeting Reason (Optional)', ar: '\u0633\u0628\u0628 \u0627\u0644\u0627\u062c\u062a\u0645\u0627\u0639 (\u0627\u062e\u062a\u064a\u0627\u0631\u064a)' },
      connectionMethod: { en: 'Connection Method', ar: '\u0637\u0631\u064a\u0642\u0629 \u0627\u0644\u0627\u062a\u0635\u0627\u0644' },
      noAgents: { en: 'No agents available for this selection', ar: '\u0644\u0627 \u064a\u0648\u062c\u062f \u0645\u0648\u0638\u0641\u064a\u0646 \u0645\u062a\u0627\u062d\u064a\u0646 \u0644\u0647\u0630\u0627 \u0627\u0644\u0627\u062e\u062a\u064a\u0627\u0631' },
      noSlots: { en: 'No available slots for this agent', ar: '\u0644\u0627 \u062a\u0648\u062c\u062f \u0645\u0648\u0627\u0639\u064a\u062f \u0645\u062a\u0627\u062d\u0629 \u0644\u0647\u0630\u0627 \u0627\u0644\u0645\u0648\u0638\u0641' },
      bookingSuccess: { en: 'Booking Confirmed!', ar: '\u062a\u0645 \u062a\u0623\u0643\u064a\u062f \u0627\u0644\u062d\u062c\u0632!' },
      bookingSuccessMsg: { en: 'Your meeting has been scheduled successfully', ar: '\u062a\u0645 \u062c\u062f\u0648\u0644\u0629 \u0627\u062c\u062a\u0645\u0627\u0639\u0643 \u0628\u0646\u062c\u0627\u062d' },
      bookAnother: { en: 'Back to My Bookings', ar: 'العودة لمواعيدي' },
      date: { en: 'Date', ar: '\u0627\u0644\u062a\u0627\u0631\u064a\u062e' },
      time: { en: 'Time', ar: '\u0627\u0644\u0648\u0642\u062a' },
      agent: { en: 'Agent', ar: '\u0627\u0644\u0645\u0648\u0638\u0641' },
      minutes: { en: 'minutes', ar: '\u062f\u0642\u064a\u0642\u0629' },
      department: { en: 'Department', ar: '\u0627\u0644\u0642\u0633\u0645' },
      step: { en: 'Step', ar: '\u062e\u0637\u0648\u0629' },
      of: { en: 'of', ar: '\u0645\u0646' },
      type: { en: 'Type', ar: '\u0627\u0644\u0646\u0648\u0639' },
      schedule: { en: 'Schedule', ar: '\u0627\u0644\u0645\u0648\u0639\u062f' },
      confirmStep: { en: 'Confirm', ar: '\u0627\u0644\u062a\u0623\u0643\u064a\u062f' },
      zoom: { en: 'Zoom', ar: 'Zoom' },
      googleMeet: { en: 'Google Meet', ar: 'Google Meet' },
      teams: { en: 'Microsoft Teams', ar: 'Microsoft Teams' },
      phone_call: { en: 'Phone Call', ar: '\u0645\u0643\u0627\u0644\u0645\u0629 \u0647\u0627\u062a\u0641\u064a\u0629' },
      in_person: { en: 'In Person', ar: '\u062d\u0636\u0648\u0631\u064a' },
      selectDate: { en: 'Select a date', ar: '\u0627\u062e\u062a\u0631 \u062a\u0627\u0631\u064a\u062e' },
      selectTime: { en: 'Select a time', ar: '\u0627\u062e\u062a\u0631 \u0648\u0642\u062a' },
      processing: { en: 'Processing...', ar: '\u062c\u0627\u0631\u064a \u0627\u0644\u0645\u0639\u0627\u0644\u062c\u0629...' },
      fillRequired: { en: 'Please fill in all required fields', ar: '\u064a\u0631\u062c\u0649 \u0645\u0644\u0621 \u062c\u0645\u064a\u0639 \u0627\u0644\u062d\u0642\u0648\u0644 \u0627\u0644\u0645\u0637\u0644\u0648\u0628\u0629' },
      selectConnection: { en: 'Please select a connection method', ar: '\u064a\u0631\u062c\u0649 \u0627\u062e\u062a\u064a\u0627\u0631 \u0637\u0631\u064a\u0642\u0629 \u0627\u0644\u0627\u062a\u0635\u0627\u0644' },
    };
    return tr[key]?.[language] || tr[key]?.['en'] || key;
  };

  useEffect(() => { loadDepartments(); }, []);

  useEffect(() => {
    if (client) {
      setFormData(prev => ({
        ...prev, name: client.name || '', email: client.email || '', phone: client.phone || ''
      }));
    }
  }, [client]);

  const loadDepartments = async () => {
    try {
      setLoading(true);
      const res = await api.get('/helpdesk/departments');
      if (res.data.success) setDepartments(res.data.departments || []);
    } catch (err) { console.error('Failed to load departments:', err); }
    finally { setLoading(false); }
  };

  const loadMeetingTypes = async (agentId) => {
    try {
      setLoading(true);
      const params = {};
      if (agentId) params.agent_id = agentId;
      const res = await api.get('/bookings/meeting-types', { params });
      if (res.data.success) {
        const types = (res.data.data || []).map(mt => ({
          ...mt, icon: MEETING_ICONS[mt.id] || '\u{1F4C5}'
        }));
        setMeetingTypes(types);
      }
    } catch (err) { console.error('Failed to load meeting types:', err); }
    finally { setLoading(false); }
  };

  const loadAgents = async (deptId, meetingType) => {
    try {
      setLoading(true);
      const params = {};
      if (deptId) params.department_id = deptId;
      if (meetingType) params.meeting_type = meetingType;
      const res = await api.get('/bookings/available-agents', { params });
      if (res.data.success) setAgents(res.data.data || []);
    } catch (err) { console.error('Failed to load agents:', err); }
    finally { setLoading(false); }
  };

  const loadSlots = async (agentId, meetingType) => {
    try {
      setLoading(true);
      const res = await api.get(`/bookings/slots/${agentId}`, {
        params: { meeting_type: meetingType, days_ahead: 14 }
      });
      if (res.data.success) {
        const allSlots = res.data.data || [];
        setSlots(allSlots);
        const dates = [...new Set(allSlots.map(s => s.date))];
        setAvailableDates(dates);
        if (dates.length > 0) setSelectedDate(dates[0]);
      }
    } catch (err) { console.error('Failed to load slots:', err); }
    finally { setLoading(false); }
  };

  // Step 1 -> 2: Select Department → Load Agents for that department
  const handleSelectDept = (dept) => {
    setSelectedDept(dept);
    setSelectedAgent(null); setSelectedType(null); setSelectedSlot(null); setSelectedDate(null);
    loadAgents(dept.id, null);
    setStep(2);
  };

  // Step 2 -> 3: Select Agent → Load Meeting Types for that agent
  const handleSelectAgent = (agent) => {
    setSelectedAgent(agent);
    setSelectedType(null); setSelectedSlot(null); setSelectedDate(null);
    loadMeetingTypes(agent.id);
    setStep(3);
  };

  // Step 3 -> 4: Select Type → Load Slots + Connection Methods
  const handleSelectType = (type) => {
    setSelectedType(type);
    setSelectedSlot(null); setSelectedDate(null);
    loadSlots(selectedAgent.id, type.id);
    loadAgentConnectionMethods(selectedAgent.id, type.id);
    setStep(4);
  };

  const loadAgentConnectionMethods = async (agentId, typeId) => {
    try {
      const res = await api.get('/bookings/meeting-types', { params: { agent_id: agentId } });
      if (res.data.success) {
        const types = res.data.data || [];
        const match = types.find(mt => mt.id === typeId);
        if (match && match.connection_methods && match.connection_methods.length > 0) {
          setAgentConnectionMethods(match.connection_methods);
        } else {
          setAgentConnectionMethods([]);
        }
      }
    } catch (err) { console.error('Failed to load connection methods:', err); }
  };

  // Step 4 -> 5
  const handleSelectSlot = (slot) => {
    setSelectedSlot(slot);
    setStep(5);
  };

  const handleBack = () => {
    setError('');
    if (step === 2) { setStep(1); setSelectedAgent(null); }
    else if (step === 3) { setStep(2); setSelectedType(null); }
    else if (step === 4) { setStep(3); setSelectedSlot(null); setSelectedDate(null); }
    else if (step === 5) { setStep(4); }
  };

  const handleSubmit = async () => {
    if (!formData.name || !formData.phone || !formData.email) {
      setError(t('fillRequired')); return;
    }
    if (!formData.connection_method) {
      setError(t('selectConnection')); return;
    }
    setLoading(true); setError('');
    try {
      const res = await api.post('/bookings/create', {
        customer_name: formData.name,
        customer_phone: formData.phone,
        customer_email: formData.email,
        agent_id: selectedAgent.id,
        meeting_type: selectedType.id,
        meeting_reason: formData.reason || `${selectedDept.name} - ${selectedType.title}`,
        booking_date: selectedSlot.date,
        start_time: selectedSlot.start_time,
        end_time: selectedSlot.end_time,
        connection_method: formData.connection_method
      });
      if (res.data.success) setBookingResult(res.data.data);
      else setError(res.data.message || 'Failed to create booking');
    } catch (err) {
      const errData = err.response?.data;
      if (errData?.message_ar && language === 'ar') {
        setError(errData.message_ar);
      } else {
        setError(errData?.message || 'An error occurred while booking');
      }
    } finally { setLoading(false); }
  };

  const resetBooking = () => {
    setStep(1); setSelectedDept(null); setSelectedType(null);
    setSelectedAgent(null); setSelectedSlot(null); setSelectedDate(null);
    setBookingResult(null); setError('');
    setFormData(prev => ({ ...prev, reason: '', connection_method: '' }));
  };

  const formatDate = (dateStr) => {
    const d = new Date(dateStr + 'T12:00:00');
    return d.toLocaleDateString(language === 'ar' ? 'ar-EG' : 'en-US', {
      weekday: 'short', month: 'short', day: 'numeric', year: 'numeric'
    });
  };

  const formatTime = (timeStr) => {
    if (!timeStr) return '';
    const [h, m] = timeStr.split(':').map(Number);
    const ampm = h >= 12 ? 'PM' : 'AM';
    const hour = h % 12 || 12;
    return `${hour}:${String(m).padStart(2, '0')} ${ampm}`;
  };

  const allConnectionMethods = [
    { id: 'zoom', label: t('zoom'), icon: '\u{1F4F9}' },
    { id: 'google_meet', label: t('googleMeet'), icon: '\u{1F3A5}' },
    { id: 'teams', label: t('teams'), icon: '\u{1F4BB}' },
    { id: 'phone_call', label: t('phone_call'), icon: '\u{1F4DE}' },
    { id: 'in_person', label: t('in_person'), icon: '\u{1F3E2}' }
  ];

  const connectionMethods = agentConnectionMethods.length > 0
    ? allConnectionMethods.filter(cm => agentConnectionMethods.includes(cm.id))
    : allConnectionMethods;

  const slotsForDate = slots.filter(s => s.date === selectedDate);

  // ==================== SUCCESS ====================
  if (bookingResult) {
    return (
      <div className={`bm-container ${isRTL ? 'rtl' : ''}`}>
        <div className="bm-success-card">
          <div className="bm-success-icon">{'\u2705'}</div>
          <h2>{t('bookingSuccess')}</h2>
          <p className="bm-success-msg">{t('bookingSuccessMsg')}</p>
          <div className="bm-summary">
            <div className="bm-summary-row">
              <span className="bm-summary-label">{t('department')}</span>
              <span className="bm-summary-value">{selectedDept?.name}</span>
            </div>
            <div className="bm-summary-row">
              <span className="bm-summary-label">{t('type')}</span>
              <span className="bm-summary-value">{selectedType?.title}</span>
            </div>
            <div className="bm-summary-row">
              <span className="bm-summary-label">{t('agent')}</span>
              <span className="bm-summary-value">{selectedAgent?.full_name}</span>
            </div>
            <div className="bm-summary-row">
              <span className="bm-summary-label">{t('date')}</span>
              <span className="bm-summary-value">{formatDate(selectedSlot?.date)}</span>
            </div>
            <div className="bm-summary-row">
              <span className="bm-summary-label">{t('time')}</span>
              <span className="bm-summary-value">{formatTime(selectedSlot?.start_time)} - {formatTime(selectedSlot?.end_time)}</span>
            </div>
          </div>
          <button className="bm-btn bm-btn-primary" onClick={() => navigate('/my-bookings')}>{t('bookAnother')}</button>
        </div>
      </div>
    );
  }

  // ==================== MAIN ====================
  return (
    <div className={`bm-container ${isRTL ? 'rtl' : ''}`}>
      <div className="bm-progress">
        {[1, 2, 3, 4, 5].map((s) => (
          <div key={s} className={`bm-progress-step ${step >= s ? 'active' : ''} ${step === s ? 'current' : ''}`}>
            <div className="bm-progress-dot">{s}</div>
            <span className="bm-progress-label">
              {s === 1 && t('department')}
              {s === 2 && t('agent')}
              {s === 3 && t('type')}
              {s === 4 && t('schedule')}
              {s === 5 && t('confirmStep')}
            </span>
          </div>
        ))}
      </div>

      <div className="bm-card">
        <div className="bm-header">
          <h2>
            {step === 1 && t('selectDepartment')}
            {step === 2 && t('selectAgent')}
            {step === 3 && t('selectMeetingType')}
            {step === 4 && t('selectDateTime')}
            {step === 5 && t('yourDetails')}
          </h2>
          <span className="bm-step-counter">{t('step')} {step} {t('of')} 5</span>
        </div>

        {error && <div className="bm-error">{error}</div>}

        {loading ? (
          <div className="bm-loading">
            <div className="bm-spinner"></div>
            <p>{t('processing')}</p>
          </div>
        ) : (
          <>
            {/* STEP 1: Department */}
            {step === 1 && (
              <div className="bm-grid">
                {departments.map((dept) => (
                  <button key={dept.id}
                    className={`bm-option-card ${selectedDept?.id === dept.id ? 'selected' : ''}`}
                    onClick={() => handleSelectDept(dept)}>
                    <div className="bm-option-icon">{'\u{1F3E2}'}</div>
                    <div className="bm-option-name">{dept.name}</div>
                  </button>
                ))}
              </div>
            )}

            {/* STEP 2: Agent */}
            {step === 2 && (
              <>
                {agents.length === 0 ? (
                  <div className="bm-empty">{t('noAgents')}</div>
                ) : (
                  <div className="bm-grid">
                    {agents.map((agent) => (
                      <button key={agent.id}
                        className={`bm-option-card bm-agent-card ${selectedAgent?.id === agent.id ? 'selected' : ''}`}
                        onClick={() => handleSelectAgent(agent)}>
                        <div className="bm-agent-avatar">
                          {agent.profile_picture
                            ? <img src={agent.profile_picture} alt={agent.full_name} />
                            : <span>{agent.full_name.charAt(0).toUpperCase()}</span>}
                        </div>
                        <div className="bm-option-name">{agent.full_name}</div>
                      </button>
                    ))}
                  </div>
                )}
                <button className="bm-btn bm-btn-back" onClick={handleBack}>
                  {isRTL ? '\u2192' : '\u2190'} {t('back')}
                </button>
              </>
            )}

            {/* STEP 3: Meeting Type */}
            {step === 3 && (
              <>
                <div className="bm-grid">
                  {meetingTypes.map((type) => (
                    <button key={type.id}
                      className={`bm-option-card ${selectedType?.id === type.id ? 'selected' : ''}`}
                      onClick={() => handleSelectType(type)}>
                      <div className="bm-option-icon">{type.icon}</div>
                      <div className="bm-option-name">{type.title}</div>
                      {type.duration && <div className="bm-option-meta">{type.duration} {t('minutes')}</div>}
                    </button>
                  ))}
                </div>
                <button className="bm-btn bm-btn-back" onClick={handleBack}>
                  {isRTL ? '\u2192' : '\u2190'} {t('back')}
                </button>
              </>
            )}

            {/* STEP 4: Date & Time */}
            {step === 4 && (
              <>
                {availableDates.length === 0 ? (
                  <div className="bm-empty">{t('noSlots')}</div>
                ) : (
                  <div className="bm-datetime">
                    <div className="bm-dates-section">
                      <h4>{t('selectDate')}</h4>
                      <div className="bm-dates-scroll">
                        {availableDates.map((date) => {
                          const d = new Date(date + 'T12:00:00');
                          const dayName = d.toLocaleDateString(language === 'ar' ? 'ar-EG' : 'en-US', { weekday: 'short' });
                          const dayNum = d.getDate();
                          const month = d.toLocaleDateString(language === 'ar' ? 'ar-EG' : 'en-US', { month: 'short' });
                          return (
                            <button key={date}
                              className={`bm-date-btn ${selectedDate === date ? 'selected' : ''}`}
                              onClick={() => { setSelectedDate(date); setSelectedSlot(null); }}>
                              <span className="bm-date-day">{dayName}</span>
                              <span className="bm-date-num">{dayNum}</span>
                              <span className="bm-date-month">{month}</span>
                            </button>
                          );
                        })}
                      </div>
                    </div>
                    <div className="bm-times-section">
                      <h4>{t('selectTime')}</h4>
                      <div className="bm-times-grid">
                        {slotsForDate.map((slot, idx) => (
                          <button key={idx}
                            className={`bm-time-btn ${selectedSlot === slot ? 'selected' : ''}`}
                            onClick={() => handleSelectSlot(slot)}>
                            {formatTime(slot.start_time)}
                          </button>
                        ))}
                      </div>
                    </div>
                  </div>
                )}
                <button className="bm-btn bm-btn-back" onClick={handleBack}>
                  {isRTL ? '\u2192' : '\u2190'} {t('back')}
                </button>
              </>
            )}

            {/* STEP 5: Details */}
            {step === 5 && (
              <>
                <div className="bm-mini-summary">
                  <span>{'\u{1F4CD}'} {selectedDept?.name}</span>
                  <span>{'\u{1F4CB}'} {selectedType?.title}</span>
                  <span>{'\u{1F464}'} {selectedAgent?.full_name}</span>
                  <span>{'\u{1F4C5}'} {formatDate(selectedSlot?.date)}</span>
                  <span>{'\u23F0'} {formatTime(selectedSlot?.start_time)}</span>
                </div>
                <div className="bm-form">
                  <div className="bm-form-group">
                    <label>{t('name')} <span className="bm-required">*</span></label>
                    <input type="text" value={formData.name}
                      onChange={(e) => setFormData({...formData, name: e.target.value})}
                      placeholder={t('name')} />
                  </div>
                  <div className="bm-form-row">
                    <div className="bm-form-group">
                      <label>{t('phone')} <span className="bm-required">*</span></label>
                      <input type="tel" value={formData.phone}
                        onChange={(e) => setFormData({...formData, phone: e.target.value})}
                        placeholder="+966..." dir="ltr" />
                    </div>
                    <div className="bm-form-group">
                      <label>{t('email')} <span className="bm-required">*</span></label>
                      <input type="email" value={formData.email}
                        onChange={(e) => setFormData({...formData, email: e.target.value})}
                        placeholder="email@example.com" dir="ltr" />
                    </div>
                  </div>
                  <div className="bm-form-group">
                    <label>{t('reason')}</label>
                    <textarea value={formData.reason}
                      onChange={(e) => setFormData({...formData, reason: e.target.value})}
                      rows={3} />
                  </div>
                  <div className="bm-form-group">
                    <label>{t('connectionMethod')} <span className="bm-required">*</span></label>
                    <div className="bm-connection-grid">
                      {connectionMethods.map((cm) => (
                        <button key={cm.id} type="button"
                          className={`bm-connection-btn ${formData.connection_method === cm.id ? 'selected' : ''}`}
                          onClick={() => setFormData({...formData, connection_method: cm.id})}>
                          <span>{cm.icon}</span>
                          <span>{cm.label}</span>
                        </button>
                      ))}
                    </div>
                  </div>
                </div>
                <div className="bm-actions">
                  <button className="bm-btn bm-btn-back" onClick={handleBack}>
                    {isRTL ? '\u2192' : '\u2190'} {t('back')}
                  </button>
                  <button className="bm-btn bm-btn-primary" onClick={handleSubmit} disabled={loading}>
                    {loading ? t('processing') : t('confirm')}
                  </button>
                </div>
              </>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default BookMeeting;